import { logger } from '@src/@data/utility/errors';
import React from 'react';
import { Button } from 'reactstrap';
import errorImg from '@src/assets/images/graphics/error.svg';
import '@styles/base/pages/page-misc.scss';

export class ErrorBoundary extends React.Component<
  Record<string, unknown>,
  { hasError: boolean }
> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    logger.error(error);
  }

  private refreshPage = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="misc-wrapper">
          <div className="misc-inner p-2 p-sm-3">
            <div className="w-100 text-center">
              <img className="img-fluid" src={errorImg} alt="Error page" />
              <h2 className="my-2">
                Something went wrong. Please try again later 🕵🏻‍♀️
              </h2>
              <Button
                onClick={this.refreshPage}
                color="primary"
                className="btn-sm-block mb-2"
              >
                Refresh
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
